module.exports = __webpack_public_path__ + "static/convo-34e30294d9169c14b78550555cb2fc2a.jpg";